<app-button-outline
  [hotButton]="saveActionHotkey"
  [action]="saveAction"
  [isHighlight]="false"
  [typeOfButton]="ButtonOutline[1]"
></app-button-outline>
